import React from 'react';
import { Box, Typography } from '@mui/material';
import { useI18next } from 'gatsby-plugin-react-i18next';
import { TicketSeason, getTicketSeasonsByMonth } from '../../../../domain/tickets';
import {
  DAY_BG_COLOR,
  DAY_TEXT_COLOR,
  getDaysOfMonth,
  getDaysOfWeekByLocale,
  getMonthsByLocale,
} from './ticket.seasons-calendar.utils';

interface Props {
  year: number;
  month: number;
}

export const TicketSeasonsCalendar = ({ year, month }: Props) => {
  const { language: locale } = useI18next();
  const daysOfWeek = getDaysOfWeekByLocale(locale);

  const daysOfMonth = getDaysOfMonth(year, month);
  const ticketSeasonsByMonth = getTicketSeasonsByMonth(month);

  return (
    <Box bgcolor="#FFFFFF" pt={4} pb={2.5} px={1.5} borderRadius={8}>
      <Typography
        color="primary.main"
        fontFamily="Gotham-Medium"
        fontSize={32}
        fontWeight={500}
        textAlign="center"
        mb={3}
      >
        {getMonthsByLocale(locale)[month]}
      </Typography>

      <Box display="grid" gridTemplateColumns="repeat(7, 1fr)" gap={0.25} borderRadius={4} overflow="hidden">
        {daysOfWeek.map((day) => (
          <Box width="100%" height={46} display="flex" justifyContent="center" alignItems="center" bgcolor="#F4F5F8">
            <Typography fontSize={24}>{day}</Typography>
          </Box>
        ))}
        {daysOfMonth.map(({ day }, index) => {
          if (!day) return <Box key={index * 100} bgcolor="#F4F5F8"></Box>;

          let ticketSeason: TicketSeason | null = null;

          if (ticketSeasonsByMonth[TicketSeason.High]) {
            for (const seasonRange of ticketSeasonsByMonth[TicketSeason.High]) {
              if (day >= seasonRange.from && (!seasonRange.to || (!!seasonRange.to && day <= seasonRange.to))) {
                ticketSeason = TicketSeason.High;
                break;
              }
            }
          }

          if (!ticketSeason && ticketSeasonsByMonth[TicketSeason.Low]) {
            for (const seasonRange of ticketSeasonsByMonth[TicketSeason.Low]) {
              if (day >= seasonRange.from && (!seasonRange.to || (!!seasonRange.to && day <= seasonRange.to))) {
                ticketSeason = TicketSeason.Low;
                break;
              }
            }
          }

          if (!ticketSeason && ticketSeasonsByMonth[TicketSeason.Regular]) {
            for (const seasonRange of ticketSeasonsByMonth[TicketSeason.Regular]) {
              if (day >= seasonRange.from && (!seasonRange.to || (!!seasonRange.to && day <= seasonRange.to))) {
                ticketSeason = TicketSeason.Regular;
                break;
              }
            }
          }

          return (
            <Box
              key={day}
              width="100%"
              height={46}
              display="flex"
              justifyContent="center"
              alignItems="center"
              bgcolor={ticketSeason ? DAY_BG_COLOR[ticketSeason] : '#F4F5F8'}
            >
              <Typography color={ticketSeason ? DAY_TEXT_COLOR[ticketSeason] : '#000000'}>{day}</Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};
